module.exports = __webpack_public_path__ + "static/img/icon_4.067976e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_4.png
// module id = l1Dj
// module chunks = 0